'use strict';

var _ = require('lodash');
var ManagedMarketFactory = function ManagedMarketFactory(SignificantPos) {
  /**
   * Create market instance
   * @param {Object} market
   * @param {boolean} [market.isNew]
   * @param {string} market.origin
   * @param {string} market.destination
   * @param {(string|boolean)} [market.isSignificant]
   * @param {string} [market.controlType=financial]
   * @param {string} [market.assignedEntity=Default]
   * @constructor
   */
  function ManagedMarket(market) {
    this.isNew = market.isNew || false;
    this.market = market.origin + '-' + market.destination;
    this.origin = market.origin;
    this.destination = market.destination;
    this.owner = market.owner;
    this._old = market.owner;
    this.isSignificant = (market.isSignificant || false).toString();
    this.controlType = market.controlType || 'financial';
    this.assignedEntity = market.assignedEntity || 'Default';

    /**
     * @type {Array.SignificantPos}
     */
    this.significantPos = [];
    var poses = market.pos && market.pos.length ? market.pos : [{
      'priority': 1,
      'spos': 'Default'
    }];

    //add initial SPOS
    var that = this;
    _.forEach(poses, function (pos) {
      that.addPos(pos);
    });
  }

  /**
   *
   * @param {object} [posData]
   * @param {SignificantPosFactory} [addAfter]
   * @returns {SignificantPosFactory}
   */
  ManagedMarket.prototype.addPos = function (posData, addAfter) {
    var pos = new SignificantPos(posData);
    var insertAfter = 0;
    if (_.isUndefined(addAfter)) {
      this.significantPos.push(pos);
    } else {
      insertAfter = this.significantPos.indexOf(addAfter) + 1;
      this.significantPos.splice(insertAfter, 0, pos);
    }
    this.reassignPosPriority();
    return pos;
  };

  /**
   *
   * @param {SignificantPosFactory} pos
   */
  ManagedMarket.prototype.removePos = function (pos) {
    var removeAt = this.significantPos.indexOf(pos);
    this.significantPos.splice(removeAt, 1);
    this.reassignPosPriority();
  };

  /**
   *
   * @param fromIndex
   * @param toIndex
   */
  ManagedMarket.prototype.movePos = function (fromIndex, toIndex) {
    this.significantPos.splice(toIndex, 0, this.significantPos.splice(fromIndex, 1)[0]);
    this.reassignPosPriority();
  };
  ManagedMarket.prototype.reassignPosPriority = function () {
    var priority = 1;
    this.significantPos.forEach(function (pos) {
      pos.priority = priority++;
    });
  };
  ManagedMarket.prototype.isSignificant = function () {
    return this.isSignificant === 'true';
  };
  return ManagedMarket;
};
ManagedMarketFactory.$inject = ['SignificantPosFactory'];
module.exports = ManagedMarketFactory;